<template>
    <div class="vacancies-page">
        <z-filter name="Фильтр">
            <z-filter-content
                v-model="filterParams"
                :structure="structure"
                @update-params="onFilterChange"
            />
        </z-filter>

        <div class="vacancies-page__preloader">
            <z-preloader v-if="isLoading"/>
        </div>

        <div class="vacancies-page__results-wrapper u-top-margin--2xl">
            <vacancies-results :data="items" v-if="items.length"/>

            <z-not-found class="vacancies-page__not-found" v-else-if="!isLoading"></z-not-found>
        </div>

        <z-pagination
            :data="paginationData"
            :loading="isLoading"
            :show-more="{text: 'Показать еще'}"
            @change-page="onPageChange"
            class="u-top-margin--xl-important"
        />

    </div>
</template>
<script setup>
import {computed, ref, watch} from 'vue'

import VacanciesResults from './components/VacanciesResults.vue'

import { useGetData } from '@/composable/useGetData'
import { useGetter } from '@/composable/useGetter'
import { useHandlers } from '@/components/ZPagination/composable/useHandlers'
import { getVacancies } from '@/api/vacancies'
import { useFiltersParams } from '@/composable/useFilter';

const params = ref({})
const { app } = useGetter(['app'])
const isMore = ref(false)
const appData = app.value.components?.vacancies
const {isLoading, data, fetcher} = useGetData(getVacancies, params, appData)

const {onPageChange, onUpdateParams, onFilterChange} = useHandlers(params, isMore, fetcher)

const paginationData = computed(() => {
    return ({
        currentPage: data.value.nav?.current || 0,
        totalItems: data.value.nav?.count || 0,
        totalPages: data.value.nav?.total || 0,
        pageRange: 1
    })
})

const items = ref(data.value.items || [])

const structure = {
    q: {
        type: 'z-input',
        value: '',
        props: {
            title: 'Поиск',
            placeholder: 'По названию',
            size: 'm',
            icon: 'tools/magnifier',
            'icon-position': 'right',
        },
        class: 'col-default-12'
    },
    organization: {
        type: 'z-select',
        value: '',
        props: {
            title: 'Организация',
            placeholder: 'Все',
            size: 'm',
            options: appData.filter['organization']
        },
        class: 'col-default-4 col-v-tablet-6 col-mobile-12'
    },
    schedule: {
        type: 'z-select',
        value: '',
        props: {
            title: 'График работы',
            placeholder: 'Любой',
            size: 'm',
            options: appData.filter['schedule']
        },
        class: 'col-default-4 col-v-tablet-6 col-mobile-12'
    },
    type: {
        type: 'z-select',
        value: '',
        props: {
            title: 'Тип вакансии',
            placeholder: 'Любой',
            size: 'm',
            options: appData.filter['type']
        },
        class: 'col-default-4 col-v-tablet-6 col-mobile-12'
    },
    education: {
        type: 'z-checkbox',
        value: false,
        props: {
            title: 'Тип вакансии',
            size: 'm',
            data: {
                value: 'Y',
                text: 'Возможно обучение',
                id: 'edu-vacancy'
            }
            
        },
        class: 'col-default-4 col-v-tablet-6 col-mobile-12 vacancies-filter__checkbox'
    },
    hot: {
        type: 'z-checkbox',
        value: false,
        props: {
            title: 'Тип вакансии',
            size: 'm',
            data: {
                value: 'Y',
                text: 'Горящая вакансия',
                id: 'hot-vacancy'
            }
        },
        class: 'col-default-4 col-v-tablet-6 col-mobile-12 vacancies-filter__checkbox'
    },
}

const filterParams = useFiltersParams(structure);

watch(data, () => {
    if (!(data.value.items && data.value.items.length)) {
        items.value = []
        return
    }

    items.value = isMore.value ? [...items.value, ...data.value.items] : items.value = data.value.items
})

</script>

<style lang="scss">
.vacancies-page__preloader {
    display: flex;
    justify-content: center;
    align-content: center;
}

.vacancies-filter__checkbox  {
    margin-bottom: 14px;
    align-self: flex-end;
}
</style>
